import { z } from 'zod';
import { traderSiteSchema } from '../traders/getTraderSites';

const groupItemTraderSite = z.object({
  id: z.string(),
  isActive: z.boolean(),
  isFromManager: z.boolean().optional(),
  groupItemId: z.string(),
  mwAccountGroupId: z.string(),
  deleted: z.boolean().optional(),
  traderSite: traderSiteSchema,
});

export const getGroupItemsTraderSiteForGroupItemIdSchema = z.array(groupItemTraderSite);

export type GetGroupItemsTraderSiteForGroupItemIdResponse = z.infer<
  typeof getGroupItemsTraderSiteForGroupItemIdSchema
>;
